import { Box } from '@mui/material';
import { Button } from '@portals/core/es/components/Button/Button';
import { ButtonGroupField } from '@portals/core/es/components/ButtonGroupField/ButtonGroupField';
import { LoadingDots } from '@portals/core/src/components/LoadingDots/LoadingDots';
import { getFixedT } from 'i18next';
import React, { ChangeEvent } from 'react';

import { ResultListTypes } from '../../../config';
import { DottedList, MapMagnifier } from '../../../icons';
import { getStyles } from './EstateResultTypeToggle.styles';

interface EstateResultTypeToggleProps {
  value?: ResultListTypes;
  onChange: (event: ChangeEvent<HTMLButtonElement>) => void;
  isStickyHeader: boolean;
  isLoading?: boolean;
}

const t = getFixedT(null, 'core-immobilien');

export const EstateResultTypeToggle: React.FC<EstateResultTypeToggleProps> = ({
  value,
  onChange,
  isStickyHeader,
  isLoading = false,
}: EstateResultTypeToggleProps) => {
  const styles = getStyles(isStickyHeader);

  return (
    <Box sx={{ display: 'inline-flex', flexGrow: 0 }}>
      <ButtonGroupField aria-label="Liste/Karte" value={value ?? ''} onChange={onChange} sx={styles.buttonGroupField}>
        <Button
          color="secondary"
          value={ResultListTypes.LIST}
          startIcon={<DottedList />}
          aria-label={t('resultType.list')}
          sx={styles.button}
        >
          <Box component="span" sx={styles.buttonText}>
            {t('resultType.list')}
          </Box>
        </Button>
        <Button
          color="secondary"
          value={ResultListTypes.MAP}
          startIcon={<MapMagnifier />}
          aria-label={t('resultType.card')}
          sx={styles.button}
        >
          <Box component="span" sx={styles.buttonText}>
            {isLoading ? <LoadingDots /> : t('resultType.card')}
          </Box>
        </Button>
      </ButtonGroupField>
    </Box>
  );
};

EstateResultTypeToggle.displayName = 'EstateResultTypeToggle';
